<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="$router.go(-1)"></span>
    </div>
    <div class="title">设置密码</div>

    <div class="weui-cells weui-cells_form">
      <div class="weui-cell weui-cells_form">
          <div class="weui-cell__hd">
              <label class="weui-label">新的密码</label>
          </div>
          <div class="weui-cell__bd">
              <input class="weui-input" :type="inputType" placeholder="请输入密码" v-model="password" />
          </div>
          <div class="weui-cell__ft showpasswd" v-if="inputType=='text'">
              <span class="icon-eye-blocked" @click="inputType='password'">点击隐藏</span> 

          </div>
          <div class="weui-cell__ft showpasswd" v-else>
              <span class="icon-eye" @click="inputType='text'">点击显示</span> 
          </div>
      </div>
    </div>
    <div class="btn-box">
      <div class="btn active" @click="checkSubmit()" >保存新密码</div>
    </div>

    <transition name="fade">
        <div id="loadingToast" v-show="isToast">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在保存修改</p>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'resetPW',
  data () {
    return {
      password:"",
      oldPW:"",
      inputType:'password',
      isToast:false
    }
  },

  methods: {
    checkReset(){
      this.localError = [];

      if (!this.password) {
        this.localError.push('请输入新密码');
      } else if (this.password.length<8 || this.password.length>20) {
        this.localError.push("请输入8~20位字符密码");
      }

      if (!this.localError.length) {
        return true;
      }
      else{
        alert(this.localError.join("，"))
        return false;
      }
    },
    checkSubmit(){
      if(this.checkReset()){
        let that = this;
        //「正在发送数据」弹窗提醒开启
        that.isToast = true;
        this.axios.post(this.apiURL()+'/globals/editPass', 
          qs.stringify(
            {
              token: localStorage.token,
              curpass: localStorage.tempPasswd,
              newpass: this.password
            }
          )
        )
        .then(function (response) {
          //「正在发送数据」弹窗提醒关闭
          that.isToast = false;
          //api返回的数据录入本地对象
          that.regRes = response.data;
          //如果注册成功，跳转去注册成功页面
          if(that.regRes.error_code==0){
            that.isToast = false;
            localStorage.removeItem('tempPasswd');
            alert("修改成功，请牢记新密码")
            if(localStorage.surveyID){
              that.$router.push('/new-user-survey');
            }
            else{
              that.$router.push('/order');
            }
          }
          else{
            alert(that.regRes.data);
            that.isToast = false;
          }
          console.log(response.data)
        })
        .catch(function (error) {
          that.isToast = false;
          alert("连接服务器失败，请检查网络并重新尝试")
        });
      }
    },
  },
  components: {
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.showpasswd{
  font-size:14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/new-password.vue